import React from 'react'
import PropTypes from 'prop-types'
import { generateWhatsappLink } from '_/utils/helpers'

const WhatsappNumberLink = ({ number }) => {
  const renderLinks = () => {
    const numbers = Array.isArray(number) ? number : [number]
    const validNumbers = numbers.filter(num => num != null && String(num).trim() !== '')
    return validNumbers.map((num, index, arr) => {
      const key = num
      const separator = index < arr.length - 1 ? ' | ' : null
      try {
        const whatsappLink = generateWhatsappLink(num)
        return (
          <React.Fragment key={key}>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              {num}
            </a>
            {separator}
          </React.Fragment>
        )
      } catch {
        return (
          <React.Fragment key={key}>
            <span>{num}</span>
            {separator}
          </React.Fragment>
        )
      }
    })
  }

  return <div>{renderLinks()}</div>
}

WhatsappNumberLink.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
}

export default WhatsappNumberLink
